export const isFaqs = (title: string) => {
  if (
    title.toLowerCase() === 'frequently asked questions' ||
    title.toLowerCase() === 'preguntas frecuentes'
  ) {
    return true;
  }
  return false;
};
